import { createContext } from 'react';
const EventContext = createContext(() => null);
const SubscribeContext = createContext((_eventname, _callback) => null);
export const EventProvider = EventContext.Provider;
export const EventConsumer = EventContext.Consumer;
export const SubscribeProvider = SubscribeContext.Provider;
export { EventContext, SubscribeContext };
